var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import usdtIcon from "../../assets/img/payment/usdt.svg";
import UsdtForm from "./forms/UsdtForm";
import ExpayForm from "./forms/ExpayForm";
import { clearUsdtState as clearUsdtStateAction } from "../../actions/recharge/creators/usdt";
var UZS_DEPOSIT_PROVIDERS = [
    {
        label: "bank_card",
        messageId: "recharge.expay.bank_card"
    },
    {
        label: "USDT",
        img: usdtIcon,
        messageId: "USDT"
    }
];
var messages = defineMessages({
    title: {
        id: "join.refill_title",
        defaultMessage: "Выберите способ пополнения"
    },
    back: {
        id: "main.back",
        defaultMessage: "Назад"
    },
    through: {
        id: "recharge.through",
        defaultMessage: "Пополнение через"
    }
});
var Uzcard = /** @class */ (function (_super) {
    __extends(Uzcard, _super);
    function Uzcard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedPayment: null
        };
        _this.componentWillUnmount = function () {
            _this.props.clearRechargeExpay();
            _this.props.clearUsdtStateAction();
            _this.setState({ selectedPayment: null });
        };
        _this.onPaymentSelect = function (providerLabel) {
            if (_this.state.selectedPayment !== providerLabel) {
                _this.props.clearRechargeExpay();
                _this.props.clearUsdtStateAction();
            }
            _this.setState({ selectedPayment: providerLabel });
        };
        _this.handleBack = function () {
            _this.props.clearRechargeExpay();
            _this.props.clearUsdtStateAction();
            _this.setState({ selectedPayment: null });
        };
        _this.handleClearUsdtSelect = function () {
            _this.props.clearUsdtStateAction();
            _this.setState({ selectedPayment: null });
        };
        _this.handleClearExpaySelect = function () {
            _this.props.clearRechargeExpay();
            _this.setState({ selectedPayment: null });
        };
        _this.getProviderTitle = function (provider) {
            if (provider.messageId === "USDT") {
                return "USDT";
            }
            return _this.props.intl.formatMessage({ id: provider.messageId });
        };
        return _this;
    }
    Uzcard.prototype.render = function () {
        var _this = this;
        var selectedPayment = this.state.selectedPayment;
        var _a = this.props, expay = _a.expay, user = _a.user, intl = _a.intl;
        var expayRefer = expay.get("refer");
        var listClass = "providers__list" + (selectedPayment ? " providers__list-selected" : "");
        var selectedProvider = UZS_DEPOSIT_PROVIDERS.find(function (p) { return p.label === selectedPayment; });
        return (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ className: "new-recharge__head" }, { children: [selectedPayment || expayRefer ? (_jsx("a", { className: "new-join__back", onClick: this.handleBack })) : (_jsx(Link, { className: "new-join__back", to: "/" })), selectedProvider ? ("".concat(intl.formatMessage(messages.through), " ").concat(this.getProviderTitle(selectedProvider))) : (_jsx(FormattedMessage, __assign({}, messages.title)))] })), !expayRefer && (_jsx("div", __assign({ className: listClass }, { children: UZS_DEPOSIT_PROVIDERS.map(function (provider) {
                        var active = selectedPayment === provider.label;
                        return (_jsx("div", __assign({ onClick: function () { return _this.onPaymentSelect(provider.label); }, className: "providers__list__item-wrapper" }, { children: _jsx("div", __assign({ className: classNames("providers__list__item", { active: active }) }, { children: provider.label === "bank_card" ? (_jsx("span", __assign({ className: "providers__list__item-label" }, { children: _jsx(FormattedMessage, { id: provider.messageId }) }))) : (_jsx("img", { height: 40, width: "auto", alt: provider.label, src: provider.img })) })) }), provider.label));
                    }) }))), selectedPayment === "bank_card" && (_jsx("div", __assign({ className: "uzcard_reacherge" }, { children: _jsx(ExpayForm, { expay: expay, user: user, rechargeExpay: this.props.rechargeExpay, clearRechargeExpay: this.props.clearRechargeExpay, checkExpayStatus: this.props.checkExpayStatus, handleClearSelect: this.handleClearExpaySelect }) }))), selectedPayment === "USDT" && (_jsx("div", __assign({ className: "uzcard_reacherge" }, { children: _jsx("div", __assign({ className: "new-recharge__wrapper", style: { padding: "20px" } }, { children: _jsx("div", __assign({ className: "toggle_content" }, { children: _jsx("div", __assign({ className: "body" }, { children: _jsx("div", __assign({ className: "forms" }, { children: _jsx(UsdtForm, { handleClearSelect: this.handleClearUsdtSelect }) })) })) })) })) })))] }));
    };
    return Uzcard;
}(React.Component));
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({ clearUsdtStateAction: clearUsdtStateAction }, dispatch);
};
export default withRouter(injectIntl(connect(null, mapDispatchToProps)(Uzcard)));



// WEBPACK FOOTER //
// ./src/components/recharge/Uzcard.jsx